import Quill from 'quill';
import { useEffect } from 'react';

import {
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';

import {
  GOOGLE_FONTS_WHITE_LIST,
  INITIAL_FONTS,
  loadFont,
  mapFonts,
} from 'hb-builder/utils/fonts';
import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import { ToolbarItemWrapper } from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const Font = () => {
  const {
    quillRef,
    format,
    options: { toolbar: toolbarOptions },
  } = useQuillEditorContext();

  const containerFonts = quillRef.current
    ? window
        .getComputedStyle(quillRef.current.container)
        .fontFamily?.split(',')
        .map((font) => font.trim())
    : [];

  const defaultFont = containerFonts[0];

  const fonts = mapFonts([
    ...(toolbarOptions?.font?.fonts ?? []),
    ...containerFonts,
    ...INITIAL_FONTS,
    ...GOOGLE_FONTS_WHITE_LIST,
  ]);

  const quillSelectionFont = format?.font || defaultFont;
  const value = quillSelectionFont;

  const handleChange = (e) => {
    loadFont(e.value);

    const { current } = quillRef;

    current?.format('font', e.value, Quill.sources.USER);
  };

  useEffect(() => {
    if (value) {
      loadFont(value);
    }
  }, [value]);

  return (
    <ToolbarItemWrapper>
      <ReactSelectInput
        id="select_option"
        ariaLabel={__('Font family')}
        name="select_with_groups"
        width={200}
        variant="small"
        value={value ? getReactSelectValue(fonts, value) : null}
        isSearchable
        options={fonts}
        onChange={handleChange}
      />
    </ToolbarItemWrapper>
  );
};

export default Font;
